import { useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useCart } from '../../context/CartContext';
import styles from './Navbar.module.css';

const Navbar = () => {
  const { user, logout, isAdmin } = useAuth();
  const { items } = useCart();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <nav className={styles.nav}>
      <div className={`container ${styles.inner}`}>
        {/* Brand */}
        <Link to="/" className={styles.brand}>
          🚲 <span>BikeRental</span>
        </Link>

        {/* Desktop links */}
        <div className={styles.links}>
          <NavLink to="/bikes"    className={({ isActive }) => isActive ? styles.activeLink : styles.link}>Bikes</NavLink>
          {user && (
            <NavLink to="/bookings" className={({ isActive }) => isActive ? styles.activeLink : styles.link}>My Bookings</NavLink>
          )}
          {isAdmin && (
            <NavLink to="/admin"  className={({ isActive }) => isActive ? styles.activeLink : styles.link}>Admin</NavLink>
          )}
        </div>

        {/* Right actions */}
        <div className={styles.actions}>
          {user ? (
            <>
              <Link to="/cart" className={styles.cartBtn}>
                🛒
                {items.length > 0 && <span className={styles.cartBadge}>{items.length}</span>}
              </Link>
              <div className={styles.userMenu}>
                <button className={styles.userBtn}>
                  <span className={styles.avatar}>{user.name?.[0]?.toUpperCase()}</span>
                  <span className={styles.userName}>{user.name}</span>
                </button>
                <div className={styles.dropdown}>
                  <Link to="/profile" className={styles.dropItem}>Profile</Link>
                  <button onClick={handleLogout} className={styles.dropItem}>Logout</button>
                </div>
              </div>
            </>
          ) : (
            <>
              <Link to="/login"    className={styles.link}>Login</Link>
              <Link to="/register" className={styles.btnPrimary}>Register</Link>
            </>
          )}
          {/* Mobile hamburger */}
          <button className={styles.hamburger} onClick={() => setMenuOpen(o => !o)}>
            {menuOpen ? '✕' : '☰'}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className={styles.mobileMenu} onClick={() => setMenuOpen(false)}>
          <NavLink to="/bikes"    className={styles.mobileLink}>Bikes</NavLink>
          {user && <NavLink to="/bookings" className={styles.mobileLink}>My Bookings</NavLink>}
          {user && <NavLink to="/cart"     className={styles.mobileLink}>Cart ({items.length})</NavLink>}
          {isAdmin && <NavLink to="/admin" className={styles.mobileLink}>Admin</NavLink>}
          {user
            ? <button onClick={handleLogout} className={styles.mobileLink}>Logout</button>
            : <NavLink to="/login" className={styles.mobileLink}>Login</NavLink>
          }
        </div>
      )}
    </nav>
  );
};

export default Navbar;
